module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 unnumbered",
    attrs: {
      "id": "inflagrante-and-delicta---the-common-period"
    }
  }, [_c('h1', {
    staticClass: "unnumbered"
  }, [_vm._v("Inflagrante and Delicta - The Common Period")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Andrew Holt McMinn was born in Surrey, England, but brought up and schooled in Kenya and Cape Town, which forms some of the back-drop for this book. He went to the University of Cape Town, where he read English and Psychology, following which he had a long career in the fashion industry, in Cape Town and in London.")]), _vm._v(" "), _c('p', [_vm._v("He lives with his three dogs Marjorie, Geraldine and Cliveyboy in South London. The inspiration for the book were his three previous dogs Lourdes, Rocco and Tubs who are now R.I.P with the Dogfather. (Romping In Paradise)")]), _vm._v(" "), _c('p', [_vm._v("This is his first novel.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0